import Vue from "vue";

export default {
  createWorkRate(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/attendance/overtime/settings/workrates", data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getWorkRate({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: true });
      const searchQuery = state.searchQuery;
      const params = {
        page: state.pageWorkRate,
        perPage: state.perPageWorkRate,
        ...(searchQuery && { search_query: searchQuery }),
      };

      Vue.$http
        .get("/attendance/overtime/settings/workrates", { params })
        .then(response => {
          commit("OVERTIME_MUTATIONS", {
            key: "tableLoading",
            value: false,
          });
          commit("OVERTIME_MUTATIONS", {
            key: "allWorkRate",
            value: response.data.results,
          });
          commit("OVERTIME_MUTATIONS", {
            key: "workRateTotal",
            value: response.data.total,
          });
          resolve(response);
        })
        .catch(error => {
          commit("OVERTIME_MUTATIONS", {
            key: "tableLoading",
            value: false,
          });
          reject(error);
        });
    });
  },
  deleteWorkRate(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/attendance/overtime/settings/workrates/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getWorkRateById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/overtime/settings/workrates/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateWorkRate(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/attendance/overtime/settings/workrates/${id}`, data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  assignEmployeeWorkrate(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `/attendance/overtime/settings/workrates/${id}/assign-employees-to-workrates`,
          data
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getOvertimes({ state, commit }) {
    const params = {
      page: state.pageOvertimes,
      per_page: state.perPageOvertimes,
      start_date: state.overtimeDate[0],
      end_date: state.overtimeDate[1],
      ...(state.overtimeSearch && { search_query: state.overtimeSearch }),
      ...(state.overtimeFilter && { status: state.overtimeFilter }),
    };
    commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: true });
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/overtimes`, {
          params,
        })
        .then(response => {
          commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: false });
          commit("OVERTIME_MUTATIONS", {
            key: "overtimes",
            value: response.data.results,
          });
          commit("OVERTIME_MUTATIONS", {
            key: "totalOvertimes",
            value: response.data.total,
          });
          resolve(response);
        })
        .catch(error => {
          commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: false });
          reject(error);
        });
    });
  },
  handleSizeChangeOvertimes({ commit, dispatch }, perPage) {
    commit("OVERTIME_MUTATIONS", {
      key: "perPageOvertimes",
      value: perPage,
    });
    commit("OVERTIME_MUTATIONS", { key: "pageOvertimes", value: 1 });
    dispatch("getOvertimes");
  },

  handleCurrentChangeOvertimes({ commit, dispatch }, page) {
    commit("OVERTIME_MUTATIONS", { key: "pageOvertimes", value: page });
    dispatch("getOvertimes");
  },

  assignEmployeeToOvertimeRule(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `/attendance/overtime/settings/overtime-rules/${id}/assign-employees-to-overtime-rule`,
          data
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  assignEmployeeToApproval(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `/attendance/overtime/settings/approvals/${id}/assign-employees
`,
          data
        )
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getWorkrateAssignable(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/overtime/settings/workrates/${id}/assignables`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAssignableOvertimeRule(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/overtime/settings/overtime-rules/${id}/assignables`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getAssignableApprovals(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/overtime/settings/approvals/${id}/assignables`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  handleSizeChangeWorkRate({ commit, dispatch }, perPageWorkRate) {
    commit("OVERTIME_MUTATIONS", {
      key: "perPageWorkRate",
      value: perPageWorkRate,
    });
    commit("OVERTIME_MUTATIONS", { key: "pageWorkRate", value: 1 });
    dispatch("getWorkRate");
  },

  handleCurrentChangeWorkRate({ commit, dispatch }, pageWorkRate) {
    commit("OVERTIME_MUTATIONS", { key: "pageWorkRate", value: pageWorkRate });
    dispatch("getWorkRate");
  },

  createRule(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/attendance/overtime/settings/overtime-rules", data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getAllRules({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: true });
      const searchQuery = state.searchQuery;
      const params = {
        page: state.pageRules,
        perPage: state.perPageRules,
        ...(searchQuery && { search_query: searchQuery }),
      };

      Vue.$http
        .get("/attendance/overtime/settings/overtime-rules", { params })
        .then(response => {
          commit("OVERTIME_MUTATIONS", {
            key: "tableLoading",
            value: false,
          });
          commit("OVERTIME_MUTATIONS", {
            key: "allRules",
            value: response.data.results,
          });
          commit("OVERTIME_MUTATIONS", {
            key: "rulesTotal",
            value: response.data.total,
          });
          resolve(response);
        })
        .catch(error => {
          commit("OVERTIME_MUTATIONS", {
            key: "tableLoading",
            value: false,
          });
          reject(error);
        });
    });
  },

  getRuleById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/overtime/settings/overtime-rules/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteRule(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/attendance/overtime/settings/overtime-rules/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  updateRule(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/attendance/overtime/settings/overtime-rules/${id}`, data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  handleSizeChangeRules({ commit, dispatch }, perPageRules) {
    commit("OVERTIME_MUTATIONS", {
      key: "perPageRules",
      value: perPageRules,
    });
    commit("OVERTIME_MUTATIONS", { key: "pageRules", value: 1 });
    dispatch("getAllRules");
  },

  handleCurrentChangeRules({ commit, dispatch }, pageRules) {
    commit("OVERTIME_MUTATIONS", { key: "pageRules", value: pageRules });
    dispatch("getAllRules");
  },

  createApprover(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/attendance/overtime/settings/approvals", data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getAllApprovers({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit("OVERTIME_MUTATIONS", { key: "tableLoading", value: true });
      const searchQuery = state.searchQuery;
      const params = {
        page: state.pageApprover,
        perPage: state.perPageApprover,
        ...(searchQuery && { search_query: searchQuery }),
      };

      Vue.$http
        .get("/attendance/overtime/settings/approvals", { params })
        .then(response => {
          commit("OVERTIME_MUTATIONS", {
            key: "tableLoading",
            value: false,
          });
          commit("OVERTIME_MUTATIONS", {
            key: "allApprover",
            value: response.data.results,
          });
          commit("OVERTIME_MUTATIONS", {
            key: "approverTotal",
            value: response.data.total,
          });
          resolve(response);
        })
        .catch(error => {
          commit("OVERTIME_MUTATIONS", {
            key: "tableLoading",
            value: false,
          });
          reject(error);
        });
    });
  },

  getApproverById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/overtime/settings/approvals/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteApprover(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/attendance/overtime/settings/approvals/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  updateApprover(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/attendance/overtime/settings/approvals/${id}`, data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  handleSizeChangeApprover({ commit, dispatch }, perPageApprover) {
    commit("OVERTIME_MUTATIONS", {
      key: "perPageApprover",
      value: perPageApprover,
    });
    commit("OVERTIME_MUTATIONS", { key: "pageApprover", value: 1 });
    dispatch("getAllApprovers");
  },

  handleCurrentChangeApprover({ commit, dispatch }, pageApprover) {
    commit("OVERTIME_MUTATIONS", { key: "pageApprover", value: pageApprover });
    dispatch("getAllApprovers");
  },
};
